export const GROUP_BY_OPTIONS = [
  "sender",
  "receiver",
  "stockPlace",
  "noGroup",
] as const;
